import { h, Fragment, ComponentChildren } from 'preact'; /** @jsx h */
import { useEffect } from 'preact/hooks';


import { ROUTES } from "@pyqml/shared";

import { Navigation } from '../components/Navigation';
import { Footer } from './Footer';
import { useEnvironment } from '../app/Environment';
import { Category } from '@pyqml/model';
import { useAuth } from '../app/AuthProvider';

export type IAppPageProps = {
    children?: ComponentChildren; 
};

import Logo from '../assets/icon.png';


/*
const categories: any = [
    {
        title: 'Category A',
        pageSlug: './category/a',
        
    },
    {
        title: 'About',
        pageSlug: 'about',
        align: 'left'
    },
    {
        title: 'Contact',
        pageSlug: 'contact',
        align: 'right',
        highlight: true
    }
];*/

export const AppPage = (props: IAppPageProps) => {

    const { subdomain } = useEnvironment();
    const { onLogout, token } = useAuth();
    
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])


    return (
        
        <Fragment>
            <Navigation.Navbar title={ "Quantum Machine Learning" /*blog?.title ?? subdomain*/ } logo={ Logo/*blog?.abstractImage ?? undefined*/ }>
            {/*
                categories?.map?.((category: Category.ICategory) => (
                    <Navigation.Item linkTo={category.categoryLink} highlight={false} align={"left"}>{category.categoryTitle}</Navigation.Item>
                ))
            */}
                <Navigation.Item linkTo={ROUTES.BLOG_ALGORITHMS} highlight={false} align={"right"}>Algorithms</Navigation.Item>
                <Navigation.Item linkTo={ROUTES.BLOG_COURSES} highlight={false} align={"right"}>Modules</Navigation.Item>
                <Navigation.Item linkTo={ROUTES.BLOG_WIKI} highlight={false} align={"right"}>Explore</Navigation.Item>
                <Navigation.Item linkTo={ROUTES.BLOG_PROJECTS} highlight={false} align={"right"}>Projects</Navigation.Item>
                <Navigation.Item linkTo={ROUTES.BLOG_POSTS} highlight={false} align={"right"}>Posts</Navigation.Item>
                <Navigation.Item linkTo={ROUTES.BLOG_BOOKS} highlight={true} align={"right"}>Books</Navigation.Item>
                
                
            {
                token && <Navigation.Item linkTo={ROUTES.BLOG_SETTINGS} highlight={false} align={"right"} >
                    <span className="iconsmall"><i className="fas fa-user"></i></span>
                </Navigation.Item>
            }
            {
                token
                ? <Navigation.Item linkTo={"/"} highlight={false} align={"right"} onClick={onLogout}>Logout</Navigation.Item>
                : <Navigation.Item linkTo={ROUTES.BLOG_LOGIN} highlight={false} align={"right"}>Login</Navigation.Item>
            }
            </Navigation.Navbar>
            
            {props.children}
            <Footer name="The PyQML Media And Press Organization" />
        </Fragment>

            
    )

}